import React, { useContext } from 'react';
import { useIntl, defineMessage } from 'react-intl';
import CustomBtn from '../../generic/CustomBtn';
import { requestApi } from '../../utils/api-request';
import { appStore } from '../../state/app';
import PopUpWrapper from './components/PopUpWrapper';

const RemoveFieldAgentPopUp = ({ showPopUp, setShowPopUp, fieldAgensInfo }) => {
  const { update } = useContext(appStore);
  const translate = useIntl();

  const fieldAgentName = fieldAgensInfo.field_agent_name;

  const deleteFA = async () => {
    await requestApi('DELETE', '/api/dashboard/field-agent', { field_agent_id: fieldAgensInfo.field_agent_id });
    const requestFieldAgentsList = await requestApi('GET', '/api/dashboard/field-agent/list');
    update('app.allFa', requestFieldAgentsList);
    setShowPopUp(!showPopUp);
  };

  const messages = defineMessage({
    removeWarning: {
      id: 'popUp.fieldAgents.remove-warning',
    },
  });

  return (
    <PopUpWrapper showPopUp={showPopUp} setShowPopUp={setShowPopUp} widthParam="width-640">
      <h3 className="assign__caption">
        {translate.formatMessage({ id: 'popUp.fieldAgents.remove' })}
      </h3>
      <p className="assign__text">
        {translate.formatMessage(messages.removeWarning, { name: fieldAgentName })}
      </p>
      <div className="assign__btn_wrapper">
        <CustomBtn
          label={translate.formatMessage({ id: 'button-cancel' })}
          customClass="btn__fa-popup btn__fa-cancel"
          handleClick={() => setShowPopUp(!showPopUp)}
        />
        <CustomBtn
          label={translate.formatMessage({ id: 'button-remove' })}
          customClass="btn__fa-popup"
          handleClick={deleteFA}
        />
      </div>
    </PopUpWrapper>
  );
};

export default RemoveFieldAgentPopUp;
